import { Dialog, Modal } from '@material-ui/core';
import queryString from 'query-string';
import { Component } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { ThunkDispatch } from 'redux-thunk';

import ForgotPassForm from 'features/forgotPass/component/forgotPassForm';
import { ResetLinkFormData, ResetPassApiData, ResetPassFormData } from 'features/forgotPass/interface/password';
import { resetPassword, sendLinkForPassReset } from 'features/forgotPass/store/password.action';

import { GreenThumbsUpIcon, OrangeLockIcon, PopupCloseIcon } from 'assets/icons';
import { hideRemindModal, showRemindModal } from 'features/login/store/login.action';
import { Action } from 'redux';
import DialogCard from 'shared/components/dialog/dialogCard';
import ErrorCard from 'shared/components/dialog/errorCard';
import InfoDialogCard from 'shared/components/dialog/infoDialog';
import Button from 'shared/components/form/button';
import { APP_URL, SectionNavigation } from 'shared/constants/common';
import { State } from 'shared/interface';
import { createIsActionLoadingSelector } from 'shared/store/loading.selectors';
import { isMobile } from 'shared/util/utility';

interface UIState {
	dialogIcon?: React.FC;
	dialogType: string;
	dialogContent: string;
	dialogMessage?: string;
	formData: ResetLinkFormData;
	navType: string;
}

interface MapStateProps {
	loading: boolean;
	remindModalOpen: boolean;
}

interface DispatchProps {
	sendLinkForPassReset: (data: ResetLinkFormData) => Promise<any>;
	resetPassword: (data: ResetPassApiData) => Promise<any>;
	hideRemindModal: () => void;
	showRemindModal: () => void;
}

interface Props extends MapStateProps, DispatchProps, WithTranslation, RouteComponentProps {}

class ForgotPass extends Component<Props> {
	state: UIState = {
		dialogType: '',
		dialogContent: '',
		formData: {
			email: '',
		},
		navType: '',
	};

	componentDidMount = () => {
		if (this.props.location.pathname === APP_URL.resetPassword) {
			const queryParams = queryString.parse(this.props.location.search);
			const { customerId, code } = queryParams;
			if (!(customerId && code)) {
				this.props.history.replace(APP_URL.home);
			}
			// if (customerId && code) {
			// 	localStorage.setItem('resetPassData', JSON.stringify({ customerId, code }));
			// } else {
			// 	this.props.history.replace(APP_URL.home)
			// }
		}
	};

	render() {
		// @TODO: this makes infinite loop and crashes the app. Why is this here?
		// if (isLoggedin()) {
		// 	this.props.history.replace(APP_URL.home);
		// 	return <></>;
		// }
		const { t } = this.props;
		return (
			<>
				<Modal className="reminder-modal" open={this.props.remindModalOpen} onClose={this.props.hideRemindModal}>
					<section className="login-section">
						<div className="login-form__wrapper mb--10">
							<div className="close__button-forgot-password pointer" onClick={this.props.hideRemindModal}>
								<PopupCloseIcon className="close-login-modal-icon" />
							</div>
							<div className="login-form-wrap">
								<ForgotPassForm
									initialValues={{
										email: '',
									}}
									onSubmit={(data) => {
										this.setState({ formData: data });
										this.setState({ dialogType: 'confirm' });
										this.props.hideRemindModal();
									}}
									handleNavTab={() => this.props.history.push(APP_URL.login, window.location.pathname)}
								/>
							</div>
						</div>
					</section>
				</Modal>
				{this.state.dialogType === 'confirm' && (
					<Dialog
						maxWidth="xs"
						fullWidth
						onClose={() => {}}
						className="custom-dialog bg--transparent custom--box-shadow text--center"
						aria-labelledby="customized-dialog"
						open={true}
					>
						<DialogCard
							className="warning--card"
							icon={() => <OrangeLockIcon className="modal--icon lock--icon" />}
							iconTitle={t('changePasswordMessage')}
							cardBottomCustom={
								<div className="card__bottom card__bottom_multi-btn">
									<Button
										className="card__bottom__btn"
										btnType="dialog-warning-cancel"
										cyTestRef="no-button"
										onClick={(e) => this.handleDialogClose()}
									>
										{t('no')}
									</Button>
									<Button
										className="card__bottom__btn"
										btnType="dialog-warning-accept"
										onClick={(e: any) => this.onForgotPassSubmit()}
										cyTestRef="yes-button"
									>
										{t('yes')}
									</Button>
								</div>
							}
						/>
					</Dialog>
				)}

				{this.state.dialogType === 'success' && (
					<InfoDialogCard
						icon={this.state.dialogIcon}
						iconTitle={this.state.dialogContent}
						successMessage={this.state.dialogMessage}
						onClose={() => {
							if (this.props.location.pathname === APP_URL.forgotPassword) {
								this.props.history.push(APP_URL.login, window.location.pathname);
							} else {
								isMobile() ? this.props.history.goBack() : this.handleDialogClose();
							}
						}}
					/>
				)}

				{this.state.dialogType === 'error' && (
					<ErrorCard
						iconTitle={this.state.dialogContent}
						onClose={() => {
							this.setState({ dialogType: '' });
						}}
					/>
				)}
			</>
		);
	}

	handleDialogClose = () => {
		this.setState({
			dialogType: '',
			dialogContent: '',
		});
	};

	onForgotPassSubmit = async () => {
		const { t } = this.props;
		this.props
			.sendLinkForPassReset(this.state.formData)
			.then((resp) => {
				if (resp && resp.data && !resp.data.isError) {
					this.setState({
						dialogType: 'success',
						dialogContent: `${t('resetLinkSent')}`,
						dialogMessage: `${t('resetLinkSentInfo')}`,
						navType: SectionNavigation.LOGIN,
					});
				} else if (resp && resp.data && resp.data.code === 423) {
					this.setState({
						dialogType: 'error',
						dialogContent: `${t('invalidEmailInput')}`,
					});
				} else {
					this.setState({
						dialogType: 'error',
						dialogContent: `${t('validationError')}`,
					});
				}
			})
			.catch((err) => {
				this.setState({
					dialogType: 'error',
					dialogContetn: `${t('validationError')}`,
				});
			});
	};

	onResetPassSubmit = async (data: ResetPassFormData) => {
		const { t } = this.props;
		// const resetPassData = JSON.parse(localStorage.getItem('resetPassData') || '{}');
		const queryParams = queryString.parse(this.props.location.search);
		const { customerId, code } = queryParams;
		const body: ResetPassApiData = {
			password: data.newPassword,
			customerId: parseInt((customerId as string) || ''),
			verificationCode: code as string,
		};
		this.props
			.resetPassword(body)
			.then((resp) => {
				if (resp && resp.data && !resp.data.isError) {
					this.setState({
						dialogIcon: () => <GreenThumbsUpIcon className="modal--icon lock--icon" />,
						dialogType: 'success',
						dialogContent: `${t('changePasswordSuccess')}`,
						dialogMessage: `${t('changePasswordSuccessInfo')}`,
						navType: SectionNavigation.HOME,
					});
				} else {
					this.setState({
						dialogType: 'error',
						dialogContent: resp && resp.data && resp.data.message ? resp.data.message : `${t('genericErrorMessage')}`,
					});
				}
			})
			.catch((err) => {
				this.setState({
					dialogType: 'error',
					dialogContent: `${t('genericErrorMessage')}`,
				});
			});
	};
}

const selectIsActionLoading = createIsActionLoadingSelector('FORGOT_PASSWORD');

const mapStateToProps = (state: State): MapStateProps => ({
	...state.login,
	loading: selectIsActionLoading(state),
	remindModalOpen: state.login.remindModalOpen,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<Record<string, unknown>, Record<string, unknown>, Action>): DispatchProps => ({
	sendLinkForPassReset: (data: ResetLinkFormData) => dispatch(sendLinkForPassReset(data)),
	resetPassword: (data: ResetPassApiData) => dispatch(resetPassword(data)),
	hideRemindModal: () => dispatch(hideRemindModal()),
	showRemindModal: () => dispatch(showRemindModal()),
});

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(withRouter(ForgotPass)));
